/**
 *  Date    : 2019/11/7
 *  Author  : Weilin
 *  Declare : user
 */
import Immutable from 'seamless-immutable';
import resourceapi from '@/api/resourceapi';

const namespace = 'resource';

export default {
  namespace,
  state: Immutable({
    productTypeList: [],
    superMerchantProductTypeList: [] // 超级作者
  }),
  reducers: {
    update: (state, { data, field }) => state.merge({ [field]: data })
  },
  actions: {
    getProductTypeList(payload) {
      return {
        type: namespace + '/update/getProductTypeList',
        field: 'productTypeList',
        promise: resourceapi.findProductTypes(payload)
      };
    },
    getSuperMerchantProductTypeList(payload) {
      return {
        type: namespace + '/update/superMerchantProductTypeList',
        field: 'superMerchantProductTypeList',
        promise: resourceapi.findProductTypes({ isSuperMerchant: true })
      };
    }
  }
};
